import APIURL from '@/api/apiUrl';
var state = {
  apiurl: {}
};
var mutations = {
  LOAD_API: function LOAD_API(state) {
    state.apiurl = APIURL;
  }
};
var actions = {};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};